$(document).ready(function () {
  $(".track_order_btn").click(function () {
   var trackId = $("#fname").val().trim();
   if (trackId !== "") {
      $(".js-expected_delivery .text-medium").text("Expected date: ");
      $(".trackOrder").css("display", "none");
     $(".no-trackOrder").css("display", "none");
     $(".before_loader-gif").css("display", "block");
    if (trackId.match("#")) {
      trackId = trackId.replace("#", "");
    }
      var idLength = trackId.length;
    if(idLength >= 5){
            var url = "https://myindiabazar.com/ensenterprises/shiprocketpbbu/shiproketapi_allbrands.php?store=indulekha&awbid="+trackId
    // var url = "https://myindiabazar.com/ensenterprises/shiprocketpbbu/shi_all_brands.php?store=indulekha&awbid="+trackId
    var orderUrl ="https://myindiabazar.com/TEST/shiprocket_order.php?ordername=" + trackId;
    $.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      success: function (result) {
        var date = result.dbc6b79c7716722c;
        var status = result.s12bf203295c014c;
        var track_status = result.s12bf2032967dter
        const dateTimeObj = new Date(date);
        const formattedDate = dateTimeObj.toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        if (result == "404") {
          $(".before_loader-gif").css("display", "none");
          $(".trackOrder").css("display", "none");
          $(".no-trackOrder").css("display", "block");
          $("#js-no-tracking_id").html(trackId);
          $(".no-track-order-discription").text(
            "Please Enter the correct Order Id or Awb Number"
          );
        }
        $("#js-expected_delivery").html("Updating");
        $("#js-tracking_status").text("Updating");
   
        if (track_status == 1) {     
          $("#js-tracking_id").html(trackId);
          $(".trackOrder").css("display", "block");
          $(".no-trackOrder").css("display", "none");
          $(".before_loader-gif").css("display", "none");
          var current_status = status;
          $("#js-tracking_status").text(current_status);
          if (current_status == "Delivered" || current_status == "delivered") {
            $(".js-expected_delivery .text-medium").text("Delivered date: ");
          }
          $("#js-expected_delivery").html(formattedDate);
          $("#js-courier_name").text("Ship Rocket");
          $(".timeStatus").text("");
          $(".order-status_track").removeClass("completed");
          var currentStatus = current_status.replace(/ +/g, "");
          if (currentStatus == "InTransit") {
            $('[data-status="InTransit"]').addClass("completed");
          }
          if (currentStatus == "Dispatched") {
            $('[data-status="InTransit"]').addClass("completed");
            $('[data-status="Dispatched"]').addClass("completed");
          }
          if (currentStatus.match(/Out/) != null) {
            $('[data-status="InTransit"]').addClass("completed");
            $('[data-status="Dispatched"]').addClass("completed");
          }
          if (currentStatus == "Delivered") {
            $('[data-status="InTransit"]').addClass("completed");
            $('[data-status="Dispatched"]').addClass("completed");
            $('[data-status="Delivered"]').addClass("completed");
          }
        }
     
        if (track_status == 0) {
          $.ajax({
            type: "GET",
            url: orderUrl,
            dataType: "json",
            async: false,
            success: function (data) {
              console.log(data,"data>>>>>>>>>>>")
              var orders = data.orders;
              console.log(orders,"orders>>>>>>>.")
              if (orders.length == 1) {
                $(".order-status_track").removeClass("completed");
                $('[data-status="confirmed"]').addClass("completed");
                $(".timeStatus").text("");
                $(".trackOrder").css("display", "block");
                $(".no-trackOrder").css("display", "none");
                $(".before_loader-gif").css("display", "none");
                $("#js-no-tracking_id").html(trackId);
                $("#js-tracking_status").text("Confirmed");
                var created_at = orders[0].created_at.split("T")[0];
                var deliveryDate = new Date(created_at);
                deliveryDate.setDate(deliveryDate.getDate() + 7);
                $('[data-status="confirmed"]')
                  .find(".timeStatus")
                  .text(created_at);
                var dt = deliveryDate.getDate();
                var mt = Months[deliveryDate.getMonth()];
                var yt = deliveryDate.getFullYear();
                $("#js-expected_delivery").html(dt + " " + mt + " " + yt);
              } else {
                $(".trackOrder").css("display", "none");
                $(".no-trackOrder").css("display", "block");
                $("#js-no-tracking_id").html(trackId);
                $(".no-track-order-discription").text(
                  "Please Enter the correct Order Id or Awb Number"
                );
              }
            },
            error: function () {
              $(".trackOrder").css("display", "none");
              $(".no-trackOrder").css("display", "block");
              $(".before_loader-gif").css("display", "none");
              $("#js-no-tracking_id").html(trackId);
              $(".no-track-order-discription").text(
                "Tracking details not found"
              );
            },
          });
        }
      },
      error: function () {},
    });
  }else{
          $(".before_loader-gif").css("display", "none");
          $(".trackOrder").css("display", "none");
          $(".no-trackOrder").css("display", "block");
          $("#js-no-tracking_id").html(trackId);
          $(".no-track-order-discription").text(
            "Please Enter the correct Order Id or Awb Number"
          );
        }
   } else {
    $("#fname").css("border-color", "red");
    }
  });
    $("#fname").on("input", function () {
    $(this).css("border-color", "");
  });
});
